export enum StepSection {
    PrimaryInfo = 'primaryInfo',
    WorkingConditions = 'workingConditions',
    WorkingHours = 'workingHours',
    Addresses = 'addresses',
    PaymentGroup = 'paymentGroup',
    Description = 'description',
    VacancyManagement = 'vacancyManagement',
    Contacts = 'contacts',
    Branding = 'branding',
    PublicationType = 'publicationType',
    TemplateName = 'templateName',
    SaveAsTemplate = 'saveAsTemplate',
    WorkPlace = 'workPlace',
    PublicationSettings = 'publicationSettings',
    PurchaseDetails = 'purchaseDetails',
}

export enum StepName {
    MainInfo = 'mainInfo',
    Contacts = 'contacts',
    PublicationType = 'publicationType',
}

export interface Step {
    name: StepName;
    sections: StepSection[];
    isStandalonable?: boolean;
    isHiddenInForm?: boolean;
    isHiddenInSidebar?: boolean;
}
